import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchSetPassword } from "./forgetPassApi";

export interface VerifyOtpState {
  setpassword: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: VerifyOtpState = {
    setpassword: [],
  status: "idle",
};

export const GetSetPassword = createAsyncThunk(
  "setPaassword",
  async (data: any) => {
    const response = await fetchSetPassword(data);
    return response;
  }
);

export const setPasswordSlice = createSlice({
  name: "setPaassword",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetSetPassword.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetSetPassword.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetSetPassword.fulfilled, (state, action) => {
        state.status = "success";
        state.setpassword = action.payload;
        localStorage.setItem('forgetpass', JSON.stringify(action.payload));
      });
  },
});

export const {} = setPasswordSlice.actions;

export const selectSetPassword = (state: RootState) => {
  return state.setPassword.setpassword;
};

export default setPasswordSlice.reducer;
